import { HTMLAttributes } from "react";

export function Layout({
  children,
  className = "",
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={`px-5 sm:px-8 mt-6 sm:mt-8 container sm:mx-auto ${className} mb-8`}
    >
      {children}
    </div>
  );
}
